import styled from 'styled-components';
import {useDispatch, useSelector} from 'react-redux';
import React from 'react';
import {NavLink, useHistory} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {Auth} from 'aws-amplify';
import {hideLoader, showLoader, toggleMobileMenuOpened} from '../../store/common/slice';
import defaultAvatar from '../../images/default_avatar.svg';
import { constants } from '../../common/constants/constants';
import logoutIcon from '../../images/newDesign/logout.svg';
import bellOutline from '../../images/newDesign/bell_outline.svg';
import {GAEvent} from '../../common/google_analytics/google_analytics';
import CacheData from '../../common/utils/cacheData';
import {BllinkLogger} from '../../common/utils/bllink_loggers';
import hamburger from '../../images/newDesign/hamburger_icon.svg';

const StyledTopBar = styled.div`
  position: absolute;
  top: 0;
  inset-inline-end: 0;
  
  .actions {
    display: flex;
    align-items: center;
  }

  .user-logo {
    width: 43px;
    height: 43px;
  }

  .top-link {
    display: block;
    border: none;
    background: transparent;
    & + .top-link {
      margin-inline-start: 23px;
    }
  }
  
  .hamburger-icon {
    display: none;
  }
  
  @media screen and (max-width: 768px) {
    .hamburger-icon {
      display: block;
      width: 30px;
      margin-inline-end: 23px;
      cursor: pointer;
    }
  }
`;

export default function ManagerTopBar() {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const userProfile = useSelector(state => state.auth.userProfile);

    const logout = async () => {
        GAEvent(constants.GoogleAnalytics.Events.login, 'logout', 1, 'logout');
        CacheData.delete('profile');
        try {
            dispatch(showLoader());
            await Auth.signOut();
        } catch (e) {
            BllinkLogger.warn(`sign out error `, e);
        } finally {
            dispatch(hideLoader());
        }
        window.location.href = `/${constants.pages.loginUrl}`;
    }

    return (
        <StyledTopBar>
            <div className='actions'>
                <div
                    className='hamburger-icon'
                    onClick={() => dispatch(toggleMobileMenuOpened())}
                >
                    <img src={hamburger} alt="mobile menu" />
                </div>

                {
                    (
                        <NavLink to={`/${constants.pages.notifications}`} className={'top-link'}>
                            <img src={bellOutline} alt="notifications"/>
                        </NavLink>
                    )
                }

                <NavLink to={`/${constants.pages.allBuildingsUrl}`} className={'top-link'}>
                    <img className="user-logo" src={userProfile.partnerLogo || defaultAvatar} alt="company logo"/>
                </NavLink>

                <button type="button" className={'top-link'} onClick={logout}>
                    <img src={logoutIcon} alt={t('login.logout')}/>
                </button>
            </div>
        </StyledTopBar>
    )
}
